import { create } from 'zustand';

import {
  type TVDLInLevelState,
  initialInLevelState
} from '@VDL/types/VDLInLevelState';
import { initialHomeState, type TVDLHomeState } from '@VDL/types/VDLHomeState';
import type {
  ILevel0Data,
  IToSaveLevel0Data
} from '@VDL/api/types/ILevel0Data';
import type { IYear } from '@VDL/api/types/IYear';
import type { VDLLevel0Type } from '@VDL/types/VDLLevel0Type';
import type { IVDLAgreement } from '@VDL/api/types/IVDLAgreement';

type DefaultIframe = {
  title: string;
  src: string;
} | null;

interface IVDLStore {
  selectedYear: number | null;
  yearList: IYear[];
  level0Data: ILevel0Data | null;
  toSaveLevel0Data: IToSaveLevel0Data[];
  level0TableType: VDLLevel0Type;
  defaultIframe: DefaultIframe;
  agreementData: IVDLAgreement[];
  setSelectedYear: (year: number | null) => void;
  setYearList: (yearsList: IYear[]) => void;
  setLevel0Data: (level0Data: ILevel0Data | null) => void;
  setToSaveLevel0Data: (toSaveLevel0Data: IToSaveLevel0Data[]) => void;
  setLevel0TableType: (level0TableType: VDLLevel0Type) => void;
  setDefaultIframe: (defaultIframe: DefaultIframe) => void;
  setAgreementData: (agreementData: IVDLAgreement[]) => void;

  // WARNING: Скорей всего всю "isEdit" логику надо убрать
  isEdit: boolean;
  isEditVDLTreeData: boolean;
  isEditEventPlan: boolean;
  setIsEdit: (isEdit: boolean) => void;
  setIsEditVDLTreeData: (isEditVDLTreeData: boolean) => void;
  setIsEditEventPlan: (isEditEventPlan: boolean) => void;

  // Общее состояние описывающее что нужно отображать внутри уровня
  inLevelState: TVDLInLevelState;
  setInLevelState: (inLevelState: TVDLInLevelState) => void;

  // Тоже самое для home
  homeState: TVDLHomeState;
  setHomeState: (homeState: TVDLHomeState) => void;

  sidebarExpanded: boolean;
  setSidebarExpanded: (sidebarExpanded: boolean) => void;
}

export const useVDLStore = create<IVDLStore>((set) => ({
  selectedYear: null,
  yearList: [],
  level0Data: null,
  toSaveLevel0Data: [],
  level0TableType: 'graph',
  defaultIframe: null,
  agreementData: [],
  setSelectedYear: (selectedYear) => set({ selectedYear }),
  setYearList: (yearList) => set({ yearList }),
  setLevel0Data: (level0Data) => set({ level0Data }),
  setToSaveLevel0Data: (toSaveLevel0Data) => set({ toSaveLevel0Data }),
  setLevel0TableType: (level0TableType) => set({ level0TableType }),
  setDefaultIframe: (defaultIframe) => set({ defaultIframe }),
  setAgreementData: (agreementData) => set({ agreementData }),

  // WARNING: Скорей всего всю "isEdit" логику надо убрать
  isEdit: false,
  isEditVDLTreeData: false,
  isEditEventPlan: false,
  setIsEdit: (isEdit) => set({ isEdit }),
  setIsEditVDLTreeData: (isEditVDLTreeData) => set({ isEditVDLTreeData }),
  setIsEditEventPlan: (isEditEventPlan) => set({ isEditEventPlan }),

  // Общее состояние описывающее что нужно отображать внутри уровня
  inLevelState: initialInLevelState,
  setInLevelState: (inLevelState) => set({ inLevelState }),

  // Тоже самое для home
  homeState: initialHomeState,
  setHomeState: (homeState) => set({ homeState }),

  sidebarExpanded: false,
  setSidebarExpanded: (sidebarExpanded) => set({ sidebarExpanded })
}));
